module.exports = __webpack_public_path__ + "img/banner_doctor_2.75977f42.png";